import React from "react";
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import ArrowUpward from '@material-ui/icons/ArrowUpward';

export interface TableHeaderCell {
    value: string | Element
    cssClass?: string
    customWidth?: number
    sortStatus: SortStatus
    empty? : boolean
}
export interface TableHeaderProps {
    tableCells: Array<TableHeaderCell>;
    dropdownInUse?: boolean;
}

export enum SortStatus {
    None,
    Ascending,
    Descending
}

export const TableHeader = ({
    ...props
}: TableHeaderProps) => {
    const tableHeaderCells = props.tableCells.map((tableHeaderCell: TableHeaderCell, index) => {
        if (tableHeaderCell.cssClass === undefined) {
            tableHeaderCell.cssClass = "";
        }
        if (tableHeaderCell.sortStatus == SortStatus.Ascending) {
            return (<React.Fragment key={`header-${index}`}><th className={tableHeaderCell.cssClass} >{tableHeaderCell.value}<ArrowUpward /></th></React.Fragment>);
        }
        else if (tableHeaderCell.sortStatus == SortStatus.Descending) {
            return (<React.Fragment key={`header-${index}`}><th className={tableHeaderCell.cssClass} >{tableHeaderCell.value}<ArrowDownward /></th></React.Fragment>);
        }
        else if (tableHeaderCell.empty) {
            return (<React.Fragment key={`header-${index}`}><td className={tableHeaderCell.cssClass} >{tableHeaderCell.value}</td></React.Fragment>);
        }
        else {
            return (<React.Fragment key={`header-${index}`}><th className={tableHeaderCell.cssClass} >{tableHeaderCell.value}</th></React.Fragment >);
        }
    }       
    );
    if (props.dropdownInUse) {
        tableHeaderCells.push(<React.Fragment key={"filler-content"}><td className={"filler-content"}></td></React.Fragment >)
    }

    return (
        <thead className={props.dropdownInUse ? `table-row-header` : `table-row-header no-dropdown`}>
            <tr>{tableHeaderCells}</tr>
        </thead>
    );
};
